export const ProjectSummarySchema = 'projectsummary';
export const ResourceSectionIdAttr = 'resourcesectionid';
export const FieldsAttr = 'fields';
export const ResourceSectionTypeAttr = 'resourcesectiontype';
export const INSERT_PROJECT_SUMMARY_COMMAND = 'insertProjectSummaryCommand';
